import { Controller } from "@hotwired/stimulus"

// Initializes a Bootstrap popover on the sidebar version label so clicking it
// reveals the deploy timestamp and other build metadata. Uses the `click`
// trigger (Safari does not reliably focus buttons on mouse click, so `focus`
// would break click-to-open on macOS/iOS Safari). Since `click` does not
// dismiss on outside-click by default, we add that behavior explicitly.
export default class extends Controller {
  connect() {
    if (!window.bootstrap?.Popover) return
    this.trigger = this.element.querySelector('[data-bs-toggle="popover"]')
    if (!this.trigger) return
    if (window.bootstrap.Popover.getInstance(this.trigger)) return
    this.popover = new window.bootstrap.Popover(this.trigger, {
      container: "body",
      customClass: "gl-sidebar-app-version-popover",
    })
    this.onDocumentClick = this.onDocumentClick.bind(this)
    document.addEventListener("click", this.onDocumentClick)
  }

  disconnect() {
    if (this.onDocumentClick) {
      document.removeEventListener("click", this.onDocumentClick)
    }
    if (this.popover) {
      this.popover.dispose()
      this.popover = null
    }
  }

  onDocumentClick(event) {
    if (!this.trigger || !this.popover) return
    if (this.trigger.contains(event.target)) return
    const tip = this.popover.tip
    if (tip && tip.contains(event.target)) return
    this.popover.hide()
  }
}
